import {
  Card,
  CardHeader,
  Switch,
  Typography
} from '@mui/material';
import {
  DataGrid,
  GridCellEditStopReasons,
  koKR
} from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { apiService } from '../../api/axiosClient';
import Spinner from '../../components/spinner';
import CustomNoRowsOverlay from '../../utils/CustomNoRowsOverlay';
import PointConfigToolbar from './PointConfigToolbar';

const currencyLocale = Intl.NumberFormat('ko-KR');

const PointConfigureTable = () => {
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [selected, setSelected] = useState([]);

    useEffect(() => {
      const loadConfigure = async () => {
        try {
            const response = await apiService.get('/pointcfg');
            setList(response.data.list);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
      }

      loadConfigure();
    }, [])

    const handleCheck = (id, checked) => {
      const updatedList = (list || []).filter(item => {
        if (item.id === id) {
          item.active = checked;
        }
        return item;
      });
  
      setList(updatedList);
    }

    const columns = [
        {
            field: '__check__',
            hideable: false,
            sortable: false,
            filterable: false,
            headerAlign: 'left'
        },
        {
            flex: 0.2,
            minWidth: 150,
            field: 'kind',
            hideable: false,
            headerName: '유형',
            renderCell: params => (
              <Typography variant='body2' sx={{ ml: 1, color: 'text.primary' }}>
                  {params.row.kind}
              </Typography>
            )
        },
        {
            flex: 0.2,
            minWidth: 50,
            field: 'point',
            hideable: false,
            headerName: '포인트',
            editable: true,
            renderCell: params => (
            <Typography variant='body2' sx={{ color: 'text.primary' }}>
                {currencyLocale.format(params.row.point)}
            </Typography>
            )
        },
        {
            flex: 0.2,
            field: 'active',
            minWidth: 50,
            headerName: '적용',
            renderCell: params => (
            <Switch
              checked={Boolean(params.row.active)}
              onChange={(e) => {
                handleCheck(params.row.id, e.target.checked)
              }}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            )
        },
        {
            flex: 0.2,
            field: 'expire',
            minWidth: 20,
            headerName: '유효기간',
            editable: true,
            renderCell: params => (
              <Typography variant='body2' sx={{ color: 'text.primary' }}>
                {params.row.expire}
              </Typography>
            )
        }
    ]

    return (
        loading ? <Spinner/> :
        <Card>
            <CardHeader 
              title='포인트 구성' 
              subheader='항목을 더블클릭을 하면 수정이 가능합니다. 해당값 수정후 엔터키를 입력하세요' />
            <DataGrid
                sx={{
                    padding: '1rem',
                    '& .MuiDataGrid-footerContainer': { display: 'none'},
                    ...((list?.length === 0) && { '& .MuiDataGrid-virtualScrollerContent': {height: '200px !important' } })
                }}
                localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
                autoHeight
                getRowId={row => row.id}                
                rows={list || []}
                columns={columns}
                components={{
                    Toolbar: PointConfigToolbar,
                    NoRowsOverlay: CustomNoRowsOverlay,
                }}
                componentsProps={{
                    toolbar: {
                        numSelected: selected?.length || 0,
                        selected,
                    }
                }}
                checkboxSelection={true}
                disableSelectionOnClick={true}
                onSelectionModelChange={(ids) => {
                  const selectedIDs = new Set(ids);
                  const selectedRows = (list || []).filter((row) =>
                    selectedIDs.has(row.id),
                  );
      
                  setSelected(selectedRows)
                }}
                experimentalFeatures={{ newEditingApi: true }}
                onCellEditStop={(params, event) => {
                  if (params.reason === GridCellEditStopReasons.enterKeyDown) {        
                    if (event.target.value?.length === 0) {
                      return
                    }

                    // change source data
                    setList((list || []).filter(item => {
                      if (item.id === params.id) {
                        item[params.field] = event.target.value
                      }

                      return item
                    }));
                  }
                }}
            />
        </Card>
  )
}

export default PointConfigureTable
